import { render, staticRenderFns } from "./room-self.vue?vue&type=template&id=abb62110"
import script from "./room-self.vue?vue&type=script&lang=js"
export * from "./room-self.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports